import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from '../helpers/string.helperts';

@Pipe({
  name: 'gioStringFormat'
})
export class GioStringFormatPipe implements PipeTransform {

  transform(value: string, options: string): unknown {

    if (!value) {
      return value;
    }

    if (options == 'phone') {
      return StringHelper.formatPhone(value);
    }


    return value;
  }

}
